// extracted by mini-css-extract-plugin
var _1 = "NotificationButton-module__buttonWrapper--el7AE";
var _2 = "NotificationButton-module__notificationButton--ReJzI";
export { _1 as "buttonWrapper", _2 as "notificationButton" }
